import React from "react";
import honeymoon from "../../images/honeymoon.JPG";
import banquet from "../../images/banquet.jpg";

export default function EventsCaro() {
  return (
    <div className=" w-full bg-cover md:mt-10 md:-ml-40 sm:p-5">
             {/*<div classname="w-full bg-cover bg-center" style={{backgroundImage:`url(${bg})`}}>
                <div className="relative bg-white z-10 m-20 ">
                  <p className="text-4xl p-3"><h1>Weddings</h1>

<h3 className="text-2xl">Sophistication. Style. Glamour. </h3>
<p className="text-xl">The
ultimate in luxury city weddings.
For a wedding experience as unique as you
we're committed to your dreams coming true,
with expert professionals who are dedicated
to getting every last detail right. This
experience also means that we're on top of
the latest trends in cuisine and décor. we
know vendors with impeccable histories of
bringing wedding ideas and venues to life.
and we're always open to trying something
new and fun.</p></p>
                </div>
             </div>
                 */}
             
                
       <img className="bg-cover" src={honeymoon} alt="img"/>
     
</div>
    
  );
}
